export default function getResource(label) {
    const resources = {
        retry: 'Retry',
        loading: 'Loading annual history',
        shopNow: 'Shop Now'
    };

    return resources[label];
}
